var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "arrowLeft_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.06 11.03H6.43l4.39-4.34c.39-.39.4-1.02 0-1.41a.987.987 0 0 0-1.41 0L3.3 11.32c-.19.19-.3.45-.3.71s.11.52.3.71l6.08 5.95a.992.992 0 0 0 1.41-.01.987.987 0 0 0-.02-1.41l-4.32-4.23h13.6c.55 0 1-.45 1-1s-.45-1-1-1z"
})));
export default SvgArrowLeft;